import { createI18n } from 'vue-i18n';

const messages = {
    'en-US': {
        CONFIRM_EXIT: 'Are you sure you want to exit?',
        CONFIRM_EXIT_COPY: 'Your changes will not be saved.',
        CANCEL: 'Cancel',
        CHARACTERS: 'Characters',
        CHECKOUT: 'Checkout',
        CONFIRM: 'Confirm',
        DOUBLE_CHECK: 'Double check your work.',
        EXIT: 'Exit',
        CONFIRM_RESET: 'Are you sure you want to reset?',
        CONFIRM_RESET_COPY: 'This will undo all changes.',
        NEXT: 'Next',
        HELP: 'Need help',
        START_OVER: 'Start Over',
        BOTTLED_FOR: 'Bottled for',
        MAKE_IT_PERSONAL: 'Now, let\'s make it personal.',
        ENTER_NAME: 'enter a name below',
        ALMOST_THERE: 'Almost there!',
        GO_BACK: 'or go back to previous step',
    },
};

export default function mergeTranslations(locale, overrides) {
    const translations = JSON.parse(JSON.stringify(messages));

    if (overrides) {
        Object.keys(translations).forEach((lang) => {
            if (overrides[lang]) {
                Object.assign(translations[lang], overrides[lang]);
            }
        });

        Object.keys(overrides).forEach((lang) => {
            if (overrides[lang]) {
                if (translations[lang] == null) {
                    translations[lang] = {};
                }
                Object.assign(translations[lang], overrides[lang]);
            }
        });
    }

    return createI18n({
        locale,

        fallbackLocale: 'en-US',

        messages: translations,

        silentFallbackWarn: true,
    });
}
